import React from 'react';
import PropTypes from 'prop-types';
import { getFontFamilyWithFallback } from '@sendwise/font-helpers';

import './Copyright.module.scss';

const Copyright = ({ designSettings, children }) => {
  const {
    footerCopyrightTextColor: color,
    bodyFont,
  } = designSettings;

  const fontFamily = getFontFamilyWithFallback(bodyFont);

  return (
    <span styleName="copyright" style={{ color, fontFamily }}>
      {children}
    </span>
  );
};

Copyright.propTypes = {
  children: PropTypes.string,
  designSettings: PropTypes.shape({
    footerCopyrightTextColor: PropTypes.string,
    bodyFont: PropTypes.string,
  }),
};

export default Copyright;


// WEBPACK FOOTER //
// ./src/js/widgets/Footer/Copyright.js